import { FC, ReactElement, useEffect, useState } from 'react';

import { useMedia } from '@pp/core/src/hooks/useMedia';

import { useRecentResultDetailStateSlice } from '../../store/slices/recentResultDetail/selectors';

import { CloseModal } from './closeModal/CloseModal';
import { DateTime } from './dateTime/DateTime';
import { ModalButton } from './modalButton/ModalButton';
import { ModalHash } from './modalValueContainer/ModalHash';
import { ModalResult } from './modalValueContainer/ModalResult';
import { MoreInfo } from './moreInfo/MoreInfo';

import styles from './RecentResultDetail.module.css';

export const RecentResultDetail: FC = (): ReactElement | null => {
  const index = useRecentResultDetailStateSlice.getHashModalData().index;
  const showDateTime = useMedia('(min-width: 1024px)');
  const [modalValuesData, setModalValuesData] = useState<ReactElement>(
    <div className={styles.currentValues}>
      <ModalHash index={index} />
      <ModalResult index={index} />
    </div>
  );

  const [direction, setDirection] = useState('');

  useEffect(() => {
    if (direction === 'leftToRight') {
      setModalValuesData(
        <>
          <div className={`${styles.currentValues} ${styles.disappearInRight}`}>
            <ModalHash index={index + 1} />
            <ModalResult index={index + 1} />
          </div>
          <div className={`${styles.currentValues} ${styles.appearInRight}`}>
            <ModalHash index={index} />
            <ModalResult index={index} />
          </div>
        </>
      );
    } else if (direction === 'rightToLeft') {
      setModalValuesData(
        <>
          <div className={`${styles.currentValues} ${styles.disappearInLeft}`}>
            <ModalHash index={index - 1} />
            <ModalResult index={index - 1} />
          </div>
          <div className={`${styles.currentValues} ${styles.appearInLeft}`}>
            <ModalHash index={index} />
            <ModalResult index={index} />
          </div>
        </>
      );
    }
  }, [direction, index]);

  const isModalOpened = useRecentResultDetailStateSlice.getModalOpenStatus();
  if (!isModalOpened) return null;

  return (
    <div className={styles.RecentResultDetail}>
      <CloseModal index={index} />
      <div className={styles.modalLower}>
        <div className={styles.modalLowerMain}>
          {showDateTime && <DateTime index={index} />}
          <ModalButton index={index} setDirection={setDirection} />
          <div className={styles.modalValues}>
            {direction === '' ? (
              <div className={styles.currentValues}>
                <ModalHash index={index} />
                <ModalResult index={index} />
              </div>
            ) : (
              modalValuesData
            )}
          </div>
          <MoreInfo />
        </div>
      </div>
    </div>
  );
};
